const Action = {
  openEditMetadata: "editMetadata",
  openSummaryMetadata: "summaryMetadata",
};

const initialState = {
  displayEditMetadata: false,
  displaySummaryMetadata: false,
  metadata: null,
};

const reducer = (_, action) => {
  switch (action.type) {
    case Action.openEditMetadata:
      return {
        displayEditMetadata: true,
        displaySummaryMetadata: false,
        metadata: action.payload,
      };

    case Action.openSummaryMetadata:
      return {
        displayEditMetadata: false,
        displaySummaryMetadata: true,
        metadata: action.payload,
      };

    default:
      throw new Error("Unhandled action type");
  }
};

export { Action, initialState, reducer };
